var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":true}},[_c('div',[_c('span',[_vm._v("DIGI MANAGER")]),_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(new Date().getFullYear()))])]),_c('div',{staticClass:"mfs-auto"},[_c('span',{staticClass:"mr-1",attrs:{"target":"_blank"}},[_vm._v("DIGISYSTEM | PRODUTOS & SOLUÇÕES")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }